import { createContext } from "react";
import { ISeatsContext } from "../../types/seats";




const SeatsContext = createContext<ISeatsContext>({
    availableSeats: 10,
    consumedSeats: 0,
    consumedPercentage: 0,
    plan: "Basic",
    billingDate: "",
    seats: null,
    lastRenewal: "",
    subscriptionStatus: false
})


export default SeatsContext;